import type { RepositoryHttp } from "@/infrastructure/repositories/http";
import type { IRoutes } from "@/types/src/backend/routes";

export class UseCaseGetJobsCount {
  constructor(private readonly repository: RepositoryHttp) {}

  public run = async () => {
    const url: IRoutes.Endpoints.Expert.Jobs.Count.GetJobsCount["url"] =
      "/expert/jobs/count";

    type Output =
      IRoutes.Endpoints.Expert.Jobs.Count.GetJobsCount["outputData"];

    const result = await this.repository.findAll<Output>(String(url));

    return result;
  };
}
